/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_AriaInputs */



/**
* | output |
* | --- |
* | "Magnified Preview" |
*
* @param {Image_Export_Magnified_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_aria = /** @type {((inputs?: Image_Export_Magnified_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Previsualisation agrandie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergrößerte Vorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima ingrandita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличенный предварительный просмотр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa ampliada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("放大预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡大プレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बड़ा किया हुआ पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização ampliada")
	return /** @type {LocalizedString} */ ("Magnified Preview")
});